import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  Request,
  RequestFilter,
  PagedResult,
  RequestDetail,
  ProcessRequestForUluroRequest,
  ProcessRequestForUluroResult,
  UserListItem,
  RequestStatusOption,
  PrintSiteOption,
  PrintLocationDetailOption,
} from '../../core';
import { PrintLocationOption } from '../../core/models/process-request.model';
import { RequestFilterOptions } from '../../infrastructure/http/repositories/requests.repository';
import { BulkUpdateRequestPayload } from '../../core/models/bulk-update-request.model';

export const RequestsPageActions = createActionGroup({
  source: 'Requests Page',
  events: {
    'Load Requests': props<{ filter?: Partial<RequestFilter> }>(),
    Search: props<{ searchTerm: string }>(),
    Sort: props<{ sortField: string }>(),
    'Change Page': props<{ page: number }>(),
    'Change Page Size': props<{ pageSize: number }>(),
    'Apply Filters': props<{ filters: Partial<RequestFilter> }>(),
    'Clear Filters': emptyProps(),
    Refresh: emptyProps(),
    'Bulk Update Requests': props<{
      payload: BulkUpdateRequestPayload;
    }>(),
  },
});

export const RequestsAPIActions = createActionGroup({
  source: 'Requests API',
  events: {
    'Load Requests Success': props<{ result: PagedResult<Request> }>(),
    'Load Requests Failure': props<{ error: string }>(),
    'Load Filter Options': emptyProps(),
    'Load Filter Options Success': props<{ options: RequestFilterOptions }>(),
    'Load Filter Options Failure': props<{ error: string }>(),
    'Bulk Update Requests Success': emptyProps(),
    'Bulk Update Requests Failure': props<{ error: string }>(),
  },
});

export const RequestDetailPageActions = createActionGroup({
  source: 'Request Detail Page',
  events: {
    'Load Request Detail': props<{ requestNumber: number }>(),
    'Update Request': props<{
      requestNumber: number;
      updates: {
        printSiteId?: number | null;
        countryCode?: string | null;
        shippingMethods?: string | null;
        isManualCheck?: boolean | null;
        sla?: boolean | null;
        contactName?: string | null;
        contactEmails?: string | null;
        contactPhone?: string | null;
        isSlaFeeWaived?: boolean | null;
        isSpecialHandling?: boolean | null;
        isGarnCorp?: boolean | null;
        newComments?: string | null;
      };
      modifiedBy: string;
    }>(),
    'Update Request Status': props<{
      requestNumber: number;
      statusId: number;
      modifiedBy: string;
    }>(),
    'Assign Request': props<{
      requestNumber: number;
      assignedUserId: number;
      assignedByUserId: number;
      modifiedBy: string;
    }>(),
    'Process Request': props<{
      requestNumber: number;
      request: ProcessRequestForUluroRequest;
    }>(),
    'Load Print Locations': emptyProps(),
    'Load Print Locations By Site': props<{ printSiteId: number }>(),
    'Load User List': emptyProps(),
    'Load Request Statuses': emptyProps(),
    'Load Print Sites': emptyProps(),
    'Clear Current Request': emptyProps(),
    'Clear Process Result': emptyProps(),
    'Clear Process Request Error': emptyProps(),
  },
});

export const CreateRequestWizardActions = createActionGroup({
  source: 'Create Request Wizard',
  events: {
    'Submit Request': props<{
      arNumber: string;
      userEmail: string;
      contactName: string;
      contactEmails: string;
      contactPhone: string;
      isExpedited: boolean;
      isSlaFeeWaived: boolean;
      requestGuid: string;
    }>(),
    'Submit Success': props<{ requestId: number }>(),
    'Submit Failure': props<{ error: string }>(),
    'Clear Wizard': emptyProps(),
  },
});

export const RequestDetailAPIActions = createActionGroup({
  source: 'Request Detail API',
  events: {
    'Load Request Detail Success': props<{ request: RequestDetail }>(),
    'Load Request Detail Failure': props<{ error: string }>(),
    'Load Request Detail Not Found': props<{ requestNumber: number }>(),
    'Update Request Success': props<{ requestNumber: number }>(),
    'Update Request Failure': props<{ error: string }>(),
    'Update Request Status Success': props<{ requestNumber: number }>(),
    'Update Request Status Failure': props<{ error: string }>(),
    'Assign Request Success': props<{ requestNumber: number }>(),
    'Assign Request Failure': props<{ error: string }>(),
    'Process Request Success': props<{
      requestNumber: number;
      result: ProcessRequestForUluroResult;
    }>(),
    'Process Request Failure': props<{ error: string }>(),
    'Load Print Locations Success': props<{
      printLocations: PrintLocationOption[];
    }>(),
    'Load Print Locations Failure': props<{ error: string }>(),
    'Load Print Locations By Site Success': props<{
      printLocations: PrintLocationDetailOption[];
    }>(),
    'Load Print Locations By Site Failure': props<{ error: string }>(),
    'Load User List Success': props<{ userList: UserListItem[] }>(),
    'Load User List Failure': props<{ error: string }>(),
    'Load Request Statuses Success': props<{
      requestStatuses: RequestStatusOption[];
    }>(),
    'Load Request Statuses Failure': props<{ error: string }>(),
    'Load Print Sites Success': props<{ printSites: PrintSiteOption[] }>(),
    'Load Print Sites Failure': props<{ error: string }>(),
  },
});
